import { defineMessages } from 'react-intl';

export const messages: {
	comingSoonTagLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	comingSoonTagLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.studio-trigger-solution-build.plan-card.card-footer.action-button.coming-soon-tag-label',
		defaultMessage: 'Coming soon',
		description:
			'Label text displayed on a badge or tag in the Studio solution build plan card footer within the AI conversation interface, indicating that a feature or action is not yet available but will be available in the future. Shown as text on a badge or tag next to or on a button. The purpose is to inform users that the functionality is planned but not currently accessible.',
	},
});
